import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import '../../styles/recipes/ShoppingListPickerDialog.css';

const NEW_LIST_OPTION = '__new__';

const ShoppingListPickerDialog = ({ shoppingLists = [], onConfirm, onCancel }) => {
  const { t } = useLanguage();
  const [selectedId, setSelectedId] = useState(
    shoppingLists.length > 0 ? String(shoppingLists[0].id) : NEW_LIST_OPTION
  );
  const [newListName, setNewListName] = useState('');

  const handleConfirm = () => {
    if (selectedId === NEW_LIST_OPTION) {
      onConfirm(null, newListName);
    } else {
      onConfirm(selectedId);
    }
  };

  return (
    <div className="shopping-list-picker-overlay" onClick={onCancel}>
      <div className="shopping-list-picker-dialog" onClick={(e) => e.stopPropagation()}>
        <h3 className="shopping-list-picker-title">
          {t('recipes.pickShoppingList') || 'Zu welcher Einkaufsliste hinzufügen?'}
        </h3>

        <div className="shopping-list-picker-options">
          {shoppingLists.map((list) => (
            <label key={list.id} className="shopping-list-picker-option">
              <input
                type="radio"
                name="shopping-list-picker"
                checked={selectedId === String(list.id)}
                onChange={() => setSelectedId(String(list.id))}
              />
              <span className="shopping-list-picker-option-name">{list.name}</span>
              <span className="shopping-list-picker-option-count">
                {(list.items || []).length} {t('shoppingList.items') || 'Artikel'}
              </span>
            </label>
          ))}

          <label className="shopping-list-picker-option">
            <input
              type="radio"
              name="shopping-list-picker"
              checked={selectedId === NEW_LIST_OPTION}
              onChange={() => setSelectedId(NEW_LIST_OPTION)}
            />
            <span className="shopping-list-picker-option-name">
              {t('recipes.newShoppingList') || '+ Neue Liste erstellen'}
            </span>
          </label>

          {selectedId === NEW_LIST_OPTION && (
            <input
              type="text"
              className="shopping-list-picker-name-input"
              placeholder={t('recipes.newShoppingListPlaceholder') || 'Name der neuen Liste (optional)'}
              value={newListName}
              onChange={(e) => setNewListName(e.target.value)}
              autoFocus
            />
          )}
        </div>

        <div className="shopping-list-picker-actions">
          <button className="btn btn-secondary" onClick={onCancel}>
            {t('recipes.cancel') || 'Abbrechen'}
          </button>
          <button className="btn btn-primary" onClick={handleConfirm}>
            {t('recipes.confirm') || 'Bestätigen'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShoppingListPickerDialog;
